module.exports = __webpack_public_path__ + "static/media/v_logo_vip-biotherm.e3f4b42b.png";